import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

/** Layout-only: the "Auctions" crumb and the permission every auction screen needs. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/auctions')({
  staticData: { crumb: 'common:nav.auctions' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'auctions.read');
  },
  component: Outlet,
});
